import './src/i18n/config';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

toast.configure();

import 'gestalt/dist/gestalt.css';
